import { secondAxios } from "../../../../../../api/axios";

export const getPvHours = async (equipId) => {
  const response = await secondAxios.get(`/cost5d/${equipId}/rev/11/pv-hours`);
  console.log({ response });
  return response.data;
};

// Get fabrications by plant ID
export const getFabricationsByPlant = async (plantId) => {
  const response = await secondAxios.get(`/fabrication/plant/${plantId}`);
  console.log("fabrication response (plant)", response.data);
  return response.data;
};

// Get timesheet data for a fabrication
export const getFabricationTimesheet = async (fabId) => {
  const response = await secondAxios.get(`/fabrication/timesheet/${fabId}`);
  console.log("fabrication timesheet response", response.data);
  // Handle both direct array response and wrapped response
  return response.data?.timesheets || response.data || [];
};